module.exports = ".color-titles {\n  color: #959595; }\n\n.centerElements {\n  margin-top: auto;\n  margin-bottom: auto;\n  padding-top: 15px; }\n"